export const ApiRankings = {
    getPlaceRankings: params => ({
        url: '/getPlaceRankings',
        method: 'GET',
        params
    })
};